import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import logError from 'util/misc/log-error';
import { isEmpty, noop, reject } from 'lodash';
import { connect } from 'react-redux';
import axios, { CancelToken } from 'axios';
import classnames from 'classnames';
import looppa from 'looppa';
import CmsError from './cms-error';
import Loader from 'components/page-loader';
import Plugin from './plugin';
import mapFacets from 'util/react/facet';

import { placeholder as placeholdersURL } from 'constants/api-urls';

class CmsPlaceholder extends PureComponent {
    static defaultProps = {
        onLoaded: noop,
        useRandomIconsLoader: true,
    };

    static propTypes = {
        // if the placeholder object will be not defined we will try to fetch it
        placeholder: PropTypes.object,
        id: PropTypes.string,
        facet: PropTypes.string,
        isCmsEditModeEnabled: PropTypes.bool.isRequired,
        onEvent: PropTypes.func,
        useRandomIconsLoader: PropTypes.bool.isRequired,
        onLoaded: PropTypes.func.isRequired,
        pathname: PropTypes.string.isRequired,
        routerCooperative: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            hasErrors: false,
            placeholder: this.props.placeholder,
        };
    }

    componentDidMount() {
        if (!this.state.placeholder) {
            this.fetch();
        }
    }

    componentWillReceiveProps({ placeholder }) {
        if (placeholder) {
            this.setState({
                placeholder,
            });
        }
    }

    componentDidUpdate() {
        if (this.props.isCmsEditModeEnabled && this.state.placeholder && !this._isRegistered) {
            this.registerToCMS(this.state.placeholder || this.props.placeholder);
            this._isRegistered = true;
        }
    }

    componentWillUnmount() {
        this.requestCancelSource.cancel();
    }

    setComponents = ({ data }) => {
        const placeholder = data.data[this.props.id];

        this.props.onLoaded();

        // skip empty object
        // they get sent somehow via backend API ¯\_(ツ)_/¯
        placeholder.plugins = reject(placeholder.plugins, isEmpty);

        this.setState({
            placeholder,
        });
    };

    _isRegistered = false;

    fetch = () => {
        axios.get(`${ placeholdersURL(this.props.id) }`, {
            cancelToken: this.requestCancelSource.token,
            params: {
                cooperative: this.props.routerCooperative,
            },
        })
            .then(this.setComponents)
            .catch((error) => {
                if (!axios.isCancel(error)) {
                    this.setState({
                        hasErrors: true,
                    });
                    this.props.onLoaded();
                    console && console.warn('placeholder loading aborted');
                }
            });
    };

    registerToCMS(placeholder) {
        if (!placeholder || !placeholder.cms) {
            logError(`It was impossible to initialise the frontend editing for the cms placeholder id="${ this.props.id }"`);
            return;
        }
        const [name, data] = placeholder.cms;
        window.CMS.$(this.refs.root).data('cms', placeholder);
        window.CMS._plugins.push([name, data]);
        new window.CMS.Plugin(name, data); // eslint-disable-line no-new
    }

    requestCancelSource = CancelToken.source();

    renderContent(isPrelaunch) {
        const { facet, isCmsEditModeEnabled, onEvent, useRandomIconsLoader } = this.props;

        if (this.state.hasErrors) {
            return <CmsError/>;
        }

        if (!this.state.placeholder && !isPrelaunch) {
            return <Loader useRandomIcon={useRandomIconsLoader}/>;
        }

        return looppa(this.state.placeholder.plugins)((component, i) => (
            <Plugin
                isCmsEditModeEnabled={isCmsEditModeEnabled}
                key={i}
                index={i}
                onEvent={onEvent}
                parent={this.state.placeholder}
                facet={facet}
                {...component}
            />
        ));
    }

    render() {
        const { facet, isCmsEditModeEnabled, pathname } = this.props;

        // TODO: remove prelaunch hack
        const isPrelaunch = pathname.includes('prelaunch-counter');

        if (!this.state.placeholder && isPrelaunch) {
            return '';
        }

        return (
            <div
                ref="root"
                className={classnames(`cms-placeholder`, this.props.id ? `cms-placeholder-${ this.props.id }` : null, mapFacets(facet, 'cms-placeholder'), {
                    'cms-placeholder--plugin__is-blocked': isCmsEditModeEnabled,
                })}>
                {this.renderContent(isPrelaunch)}
            </div>
        );
    }
}


export default connect(
    reduxUtils.mapStateToProps({
        isCmsEditModeEnabled: 'cms.isEditModeEnabled',
        pathname: 'router.location.pathname',
        routerCooperative: 'router.cooperative',
    }),
)(CmsPlaceholder);




// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/index.js